import { Box } from '@chakra-ui/react';
import { useSortedUnfilteredGoalsForPageMode } from '@common/react/goals';
import { Fragment } from 'react';
import FadeInBox from '../common/FadeInBox';
import GoalItem from '../goals/GoalItem';
import CarouselPill from './CarouselPill';

const DashboardCarousel = () => {
    const { loading, goals } = useSortedUnfilteredGoalsForPageMode();

    if (!loading && goals && goals.length === 0) return <></>;

    return (
        <Box
            position="relative"
            sx={{
                maskImage:
                    'linear-gradient(to right, black 95%, transparent 100%)',
                WebkitMaskImage:
                    'linear-gradient(to right, black 95%, transparent 100%)',
            }}
        >
            <FadeInBox
                flexDirection="row"
                h={16}
                pt={2}
                gap={3}
                align="center"
                overflowX="auto"
                overflowY="hidden"
                pr="5%"
                sx={{
                    scrollbarWidth: 'none',
                    '::-webkit-scrollbar': { display: 'none' },
                }}
            >
                {loading || !goals ? (
                    <Fragment key="dashboard-goal-tiles-loading">
                        {Array.from({ length: 3 }).map((_, i) => (
                            <CarouselPill
                                key={`goal-carousel-pill-loading-${i}`}
                                isLoading
                            />
                        ))}
                    </Fragment>
                ) : (
                    <Fragment key="dashboard-goal-tiles-loaded">
                        {goals.map((g) => (
                            <GoalItem
                                key={`goal-carousel-pill-${g.id}`}
                                goal={g}
                                variant="pill"
                            />
                        ))}
                    </Fragment>
                )}
            </FadeInBox>
        </Box>
    );
};

export default DashboardCarousel;
